import { useRouter } from 'next/router'
import { useCallback, useEffect, useState } from 'react'
import { createContainer } from 'unstated-next'

import { SizeChart } from '../../../components/pages/products/ProductPage/DetailsSection/SizesSection/SizeChart'

import type { Open, State } from './types'

function useSizeChart(initialState: State | undefined = { modalState: 'Unopened' }) {
  const [state, setState] = useState<State>(initialState)
  const shouldDisplaySizeChartModal = state.modalState === 'Open'
  const router = useRouter()
  const openSizeChartModal = useCallback(
    (sizeChart?: SizeChart, initialActiveTab?: number): void => {
      setState({
        sizeChart: sizeChart,
        modalState: 'Open',
        initialActiveTab: initialActiveTab ?? 0,
      })
    },
    []
  )

  const closeSizeChartModal = useCallback((): void => {
    setState(current => ({
      ...(current as Open),
      modalState: 'Closed',
    }))
  }, [])

  useEffect(() => {
    if (state.modalState !== 'Open') return

    router.events.on('routeChangeStart', closeSizeChartModal)
    return () => {
      router.events.off('routeChangeStart', closeSizeChartModal)
    }
  }, [closeSizeChartModal, router.events, state.modalState])

  return {
    closeSizeChartModal,
    openSizeChartModal,
    shouldDisplaySizeChartModal,
    state,
  }
}

export const SizeChartModalService = createContainer(useSizeChart)
